import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { useNavigate } from "react-router";
import LoadingPage from "../../../Components/layouts/loading";
import { cropUpdateInfo } from "../../../SchemaInfo/info";
import { cropUpdateInfoSchema } from "../../../Schemas/Crop Update/crop_update_create";
import FormSubmitButton from "../../../Components/layouts/formSubmitButton";
import SimpleButton from "../../../Components/layouts/simple_button";
import { Formik, Form, FieldArray } from "formik";
import CustomInput from "../../../CustomComponent/custom_input";
import CustomSelect from "../../../CustomComponent/custom_select";
import Footer from "../../../Components/Footer/footer";
import { Toast } from "../../../CustomComponent/toast";
import performRequest from "../../../api/request";
import { PiPottedPlantDuotone } from "react-icons/pi";
import { uploadImage } from "../../../CustomComponent/upload_Image";
import { CustomErrorResponse } from "../../../CustomComponent/custom_error_response";
import CustomCheckbox from "../../../CustomComponent/custom_checkbox";
import getFilteredURL from "../../../Components/Functions/filters.getUrl";

let growbagSchedule = [
  {
    Day: 1,
    Activity: "",
    pH: "5 to 7",
    EC: "1.6 – 1.8 mS/cm (1000 – 1200 ppm)",
    Timer: "Timer: 10 minutes on and 3Hrs off",
    Composition: "",
  },
  {
    Day: 2,
    Activity: "",
    pH: "5 to 7",
    EC: "1.6 – 1.8 mS/cm (1000 – 1200 ppm)",
    Timer: "Timer: 10 minutes on and 3Hrs off",
    Composition: "",
  },
  {
    Day: 3,
    Activity: "Fertigation",
    pH: "5 to 7",
    EC: "1.6 – 1.8 mS/cm (1000 – 1200 ppm)",
    Timer: "Timer: 10 minutes on and 3Hrs off",
    Composition: "19:19:19 (1.8g/L) + Humic acid (1ml/L)",
  },
  {
    Day: 4,
    Activity: "",
    pH: "5 to 7",
    EC: "1.6 – 1.8 mS/cm (1000 – 1200 ppm)",
    Timer: "Timer: 10 minutes on and 3Hrs off",
    Composition: "",
  },
  {
    Day: 5,
    Activity: "",
    pH: "5 to 7",
    EC: "1.6 – 1.8 mS/cm (1000 – 1200 ppm)",
    Timer: "Timer: 10 minutes on and 3Hrs off",
    Composition: "",
  },
  {
    Day: 6,
    Activity: "Drenching",
    pH: "5 to 7",
    EC: "1.6 – 1.8 mS/cm (1000 – 1200 ppm)",
    Timer: "Timer: 10 minutes on and 3Hrs off",
    Composition: "Trichoderma + Pseudomonas (1.5ml/L)",
  },
  {
    Day: 7,
    Activity: "",
    pH: "5 to 7",
    EC: "1.6 – 1.8 mS/cm (1000 – 1200 ppm)",
    Timer: "Timer: 10 minutes on and 3Hrs off",
    Composition: "",
  },
  {
    Day: 8,
    Activity: "Fertigation",
    pH: "5 to 7",
    EC: "1.6 – 1.8 mS/cm (1000 – 1200 ppm)",
    Timer: "Timer: 10 minutes on and 3Hrs off",
    Composition: "19:19:19 (1.8g/L) + Humic acid (1ml/L)",
  },
  {
    Day: 9,
    Activity: "",
    pH: "5 to 7",
    EC: "1.6 – 1.8 mS/cm (1000 – 1200 ppm)",
    Timer: "Timer: 10 minutes on and 3Hrs off",
    Composition: "",
  },
  {
    Day: 10,
    Activity: "",
    pH: "5 to 7",
    EC: "1.6 – 1.8 mS/cm (1000 – 1200 ppm)",
    Timer: "Timer: 10 minutes on and 3Hrs off",
    Composition: "",
  },
  {
    Day: 11,
    Activity: "Spray",
    pH: "5 to 7",
    EC: "1.6 – 1.8 mS/cm (1000 – 1200 ppm)",
    Timer: "Timer: 10 minutes on and 3Hrs off",
    Composition:
      "Neem oil 1500 ppm (5ml/L) + sticker (spray early morning or late evening)",
  },
  {
    Day: 12,
    Activity: "Fertigation",
    pH: "5 to 7",
    EC: "1.6 – 1.8 mS/cm (1000 – 1200 ppm)",
    Timer: "Timer: 10 minutes on and 3Hrs off",
    Composition: "19:19:19 (1.8g/L) + Humic acid (1ml/L)",
  },
  {
    Day: 13,
    Activity: "",
    pH: "5 to 7",
    EC: "1.6 – 1.8 mS/cm (1000 – 1200 ppm)",
    Timer: "Timer: 10 minutes on and 3Hrs off",
    Composition: "",
  },
  {
    Day: 14,
    Activity: "Spray",
    pH: "5 to 7",
    EC: "1.6 – 1.8 mS/cm (1000 – 1200 ppm)",
    Timer: "Timer: 10 minutes on and 3Hrs off",
    Composition: "Amino acid-based growth promoter (2ml/L)",
  },
  {
    Day: 15,
    Activity: "",
    pH: "5 to 7",
    EC: "1.6 – 1.8 mS/cm (1000 – 1200 ppm)",
    Timer: "Timer: 10 minutes on and 3Hrs off",
    Composition: "",
  },
  {
    Day: 16,
    Activity: "Fertigation",
    pH: "5 to 7",
    EC: "1.6 – 1.8 mS/cm (1000 – 1200 ppm)",
    Timer: "Timer: 10 minutes on and 3Hrs off",
    Composition: "19:19:19 (1.8g/L) + Humic acid (1ml/L)",
  },
  {
    Day: 17,
    Activity: "",
    pH: "5 to 7",
    EC: "1.6 – 1.8 mS/cm (1000 – 1200 ppm)",
    Timer: "Timer: 10 minutes on and 3Hrs off",
    Composition: "",
  },
  {
    Day: 18,
    Activity: "",
    pH: "5 to 7",
    EC: "1.6 – 1.8 mS/cm (1000 – 1200 ppm)",
    Timer: "Timer: 10 minutes on and 3Hrs off",
    Composition: "",
  },
  {
    Day: 19,
    Activity: "",
    pH: "5 to 7",
    EC: "1.6 – 1.8 mS/cm (1000 – 1200 ppm)",
    Timer: "Timer: 10 minutes on and 3Hrs off",
    Composition: "",
  },
  {
    Day: 20,
    Activity: "Fertigation",
    pH: "5 to 7",
    EC: "1.6 – 1.8 mS/cm (1000 – 1200 ppm)",
    Timer: "Timer: 15 minutes on and 3Hrs off",
    Composition: "19:19:19 (1.8g/L) + CaNO3 (1.8g/L), MgSO4 (0.5g/L)",
  },
  {
    Day: 21,
    Activity: "",
    pH: "5 to 7",
    EC: "1.9 – 2.5 mS/cm (1200 – 1600 ppm)",
    Timer: "Timer: 15 minutes on and 3Hrs off",
    Composition: "",
  },
  {
    Day: 22,
    Activity: "",
    pH: "5 to 7",
    EC: "1.9 – 2.5 mS/cm (1200 – 1600 ppm)",
    Timer: "Timer: 15 minutes on and 3Hrs off",
    Composition: "",
  },
  {
    Day: 23,
    Activity: "",
    pH: "5 to 7",
    EC: "1.9 – 2.5 mS/cm (1200 – 1600 ppm)",
    Timer: "Timer: 15 minutes on and 3Hrs off",
    Composition: "",
  },
  {
    Day: 24,
    Activity: "Fertigation",
    pH: "5 to 7",
    EC: "1.9 – 2.5 mS/cm (1200 – 1600 ppm)",
    Timer: "Timer: 15 minutes on and 3Hrs off",
    Composition: "19:19:19 (1.8g/L) + CaNO3 (1.8g/L), MgSO4 (0.5g/L)",
  },
  {
    Day: 25,
    Activity: "",
    pH: "5 to 7",
    EC: "1.9 – 2.5 mS/cm (1200 – 1600 ppm)",
    Timer: "Timer: 15 minutes on and 3Hrs off",
    Composition: "",
  },
  {
    Day: 26,
    Activity: "",
    pH: "5 to 7",
    EC: "1.9 – 2.5 mS/cm (1200 – 1600 ppm)",
    Timer: "Timer: 15 minutes on and 3Hrs off",
    Composition: "",
  },
  {
    Day: 27,
    Activity: "Spray",
    pH: "5 to 7",
    EC: "1.9 – 2.5 mS/cm (1200 – 1600 ppm)",
    Timer: "Timer: 15 minutes on and 3Hrs off",
    Composition:
      "Micronutrient Spray (1.5ml/L) (spray early morning or late evening)",
  },
  {
    Day: 28,
    Activity: "Fertigation",
    pH: "5 to 7",
    EC: "1.9 – 2.5 mS/cm (1200 – 1600 ppm)",
    Timer: "Timer: 15 minutes on and 3Hrs off",
    Composition: "19:19:19 (1.8g/L) + CaNO3 (1.8g/L), MgSO4 (0.5g/L)",
  },
  {
    Day: 29,
    Activity: "",
    pH: "5 to 7",
    EC: "1.9 – 2.5 mS/cm (1200 – 1600 ppm)",
    Timer: "Timer: 15 minutes on and 3Hrs off",
    Composition: "",
  },
  {
    Day: 30,
    Activity: "",
    pH: "5 to 7",
    EC: "1.9 – 2.5 mS/cm (1200 – 1600 ppm)",
    Timer: "Timer: 15 minutes on and 3Hrs off",
    Composition: "",
  },
  {
    Day: 31,
    Activity: "Fertigation",
    pH: "5 to 7",
    EC: "1.9 – 2.5 mS/cm (1200 – 1600 ppm)",
    Timer: "Timer: 15 minutes on and 3Hrs off",
    Composition: "19:19:19 (1.8g/L) + CaNO3 (1.8g/L), MgSO4 (0.5g/L)",
  },
  {
    Day: 32,
    Activity: "Spray",
    pH: "5 to 7",
    EC: "1.9 – 2.5 mS/cm (1200 – 1600 ppm)",
    Timer: "Timer: 15 minutes on and 3Hrs off",
    Composition:
      "Spinosad or Emamectin Benzoate (1g/L) (spray early morning or late evening)",
  },
  {
    Day: 33,
    Activity: "",
    pH: "5 to 7",
    EC: "1.9 – 2.5 mS/cm (1200 – 1600 ppm)",
    Timer: "Timer: 15 minutes on and 3Hrs off",
    Composition: "",
  },
  {
    Day: 34,
    Activity: "",
    pH: "5 to 7",
    EC: "1.9 – 2.5 mS/cm (1200 – 1600 ppm)",
    Timer: "Timer: 15 minutes on and 3Hrs off",
    Composition: "",
  },
  {
    Day: 35,
    Activity: "Fertigation",
    pH: "5 to 7",
    EC: "1.9 – 2.5 mS/cm (1200 – 1600 ppm)",
    Timer: "Timer: 15 minutes on and 3Hrs off",
    Composition: "19:19:19 (1.8g/L) + CaNO3 (1.8g/L), MgSO4 (0.5g/L)",
  },
  {
    Day: 36,
    Activity: "",
    pH: "5 to 7",
    EC: "1.9 – 2.5 mS/cm (1200 – 1600 ppm)",
    Timer: "Timer: 15 minutes on and 3Hrs off",
    Composition: "",
  },
  {
    Day: 37,
    Activity: "Drenching",
    pH: "5 to 7",
    EC: "1.9 – 2.5 mS/cm (1200 – 1600 ppm)",
    Timer: "Timer: 15 minutes on and 3Hrs off",
    Composition: "Bacillus subtilis (2ml/L)",
  },
  {
    Day: 38,
    Activity: "",
    pH: "5 to 7",
    EC: "1.9 – 2.5 mS/cm (1200 – 1600 ppm)",
    Timer: "Timer: 15 minutes on and 3Hrs off",
    Composition: "",
  },
  {
    Day: 39,
    Activity: "Fertigation",
    pH: "5 to 7",
    EC: "1.9 – 2.5 mS/cm (1200 – 1600 ppm)",
    Timer: "Timer: 15 minutes on and 3Hrs off",
    Composition: "19:19:19 (1.8g/L) + CaNO3 (1.8g/L), MgSO4 (0.5g/L)",
  },
  {
    Day: 40,
    Activity: "",
    pH: "5 to 7",
    EC: "1.9 – 2.5 mS/cm (1200 – 1600 ppm)",
    Timer: "Timer: 15 minutes on and 3Hrs off",
    Composition: "",
  },
  {
    Day: 41,
    Activity: "",
    pH: "5 to 7",
    EC: "1.9 – 2.5 mS/cm (1200 – 1600 ppm)",
    Timer: "Timer: 15 minutes on and 3Hrs off",
    Composition: "",
  },
  {
    Day: 42,
    Activity: "Fertigation",
    pH: "5 to 7",
    EC: "1.9 – 2.5 mS/cm (1200 – 1600 ppm)",
    Timer: "Timer: 15 minutes on and 3Hrs off",
    Composition: "19:19:19 (1.8g/L) + CaNO3 (1.8g/L), MgSO4 (0.5g/L)",
  },
  {
    Day: 43,
    Activity: "Spray",
    pH: "5 to 7",
    EC: "1.9 – 2.5 mS/cm (1200 – 1600 ppm)",
    Timer: "Timer: 15 minutes on and 3Hrs off",
    Composition:
      "Amino acid-based growth promoter (spray early morning or late evening)",
  },
  {
    Day: 44,
    Activity: "",
    pH: "5 to 7",
    EC: "1.9 – 2.5 mS/cm (1200 – 1600 ppm)",
    Timer: "Timer: 15 minutes on and 3Hrs off",
    Composition: "",
  },
  {
    Day: 45,
    Activity: "",
    pH: "5 to 7",
    EC: "1.9 – 2.5 mS/cm (1200 – 1600 ppm)",
    Timer: "Timer: 15 minutes on and 3Hrs off",
    Composition: "",
  },
  {
    Day: 46,
    Activity: "Fertigation",
    pH: "5 to 7",
    EC: "1.9 – 2.5 mS/cm (1200 – 1600 ppm)",
    Timer: "Timer: 15 minutes on and 3Hrs off",
    Composition: "19:19:19 (1.8g/L) + CaNO3 (1.8g/L), MgSO4 (0.5g/L)",
  },
  {
    Day: 47,
    Activity: "",
    pH: "5 to 7",
    EC: "1.9 – 2.5 mS/cm (1200 – 1600 ppm)",
    Timer: "Timer: 15 minutes on and 3Hrs off",
    Composition: "",
  },
  {
    Day: 48,
    Activity: "",
    pH: "5 to 7",
    EC: "1.9 – 2.5 mS/cm (1200 – 1600 ppm)",
    Timer: "Timer: 15 minutes on and 3Hrs off",
    Composition: "",
  },
  {
    Day: 49,
    Activity: "Fertigation",
    pH: "5 to 7",
    EC: "1.9 – 2.5 mS/cm (1200 – 1600 ppm)",
    Timer: "Timer: 15 minutes on and 3Hrs off",
    Composition: "12:61:00 (1.5g/L) + CaNO3 (2g/L) + Boron (0.5g/L)",
  },
  {
    Day: 50,
    Activity: "",
    pH: "5 to 7",
    EC: "1.9 – 2.5 mS/cm (1200 – 1600 ppm)",
    Timer: "Timer: 15 minutes on and 3Hrs off",
    Composition: "",
  },
  {
    Day: 51,
    Activity: "",
    pH: "5 to 7",
    EC: "1.9 – 2.5 mS/cm (1200 – 1600 ppm)",
    Timer: "Timer: 15 minutes on and 3Hrs off",
    Composition: "",
  },
  {
    Day: 52,
    Activity: "Fertigation",
    pH: "5 to 7",
    EC: "1.9 – 2.5 mS/cm (1200 – 1600 ppm)",
    Timer: "Timer: 15 minutes on and 3Hrs off",
    Composition: "12:61:00 (1.5g/L) + CaNO3 (2g/L) + Boron (0.5g/L)",
  },
  {
    Day: 53,
    Activity: "",
    pH: "5 to 7",
    EC: "1.9 – 2.5 mS/cm (1200 – 1600 ppm)",
    Timer: "Timer: 15 minutes on and 3Hrs off",
    Composition: "",
  },
  {
    Day: 54,
    Activity: "Spray",
    pH: "5 to 7",
    EC: "1.9 – 2.5 mS/cm (1200 – 1600 ppm)",
    Timer: "Timer: 15 minutes on and 3Hrs off",
    Composition:
      "Micronutrient Spray (1.5ml/L) (spray early morning or late evening)",
  },
  {
    Day: 55,
    Activity: "",
    pH: "5 to 7",
    EC: "1.9 – 2.5 mS/cm (1200 – 1600 ppm)",
    Timer: "Timer: 15 minutes on and 3Hrs off",
    Composition: "",
  },
  {
    Day: 56,
    Activity: "Fertigation",
    pH: "5 to 7",
    EC: "1.9 – 2.5 mS/cm (1200 – 1600 ppm)",
    Timer: "Timer: 15 minutes on and 3Hrs off",
    Composition: "12:61:00 (1.5g/L) + CaNO3 (2g/L) + Boron (0.5g/L)",
  },
  {
    Day: 57,
    Activity: "",
    pH: "5 to 7",
    EC: "1.9 – 2.5 mS/cm (1200 – 1600 ppm)",
    Timer: "Timer: 15 minutes on and 3Hrs off",
    Composition: "",
  },
  {
    Day: 58,
    Activity: "Spray",
    pH: "5 to 7",
    EC: "1.9 – 2.5 mS/cm (1200 – 1600 ppm)",
    Timer: "Timer: 15 minutes on and 3Hrs off",
    Composition:
      "Lambda-cyhalothrin (1ml/L) (spray early morning or late evening)",
  },
  {
    Day: 59,
    Activity: "",
    pH: "5 to 7",
    EC: "1.9 – 2.5 mS/cm (1200 – 1600 ppm)",
    Timer: "Timer: 15 minutes on and 3Hrs off",
    Composition: "",
  },
  {
    Day: 60,
    Activity: "Fertigation",
    pH: "5 to 7",
    EC: "1.9 – 2.5 mS/cm (1200 – 1600 ppm)",
    Timer: "Timer: 15 minutes on and 3Hrs off",
    Composition: "12:61:00 (1.5g/L) + CaNO3 (2g/L) + Boron (0.5g/L)",
  },
  {
    Day: 61,
    Activity: "",
    pH: "5 to 7",
    EC: "1.9 – 2.5 mS/cm (1200 – 1600 ppm)",
    Timer: "Timer: 15 minutes on and 3Hrs off",
    Composition: "",
  },
  {
    Day: 62,
    Activity: "",
    pH: "5 to 7",
    EC: "1.9 – 2.5 mS/cm (1200 – 1600 ppm)",
    Timer: "Timer: 15 minutes on and 3Hrs off",
    Composition: "",
  },
  {
    Day: 63,
    Activity: "",
    pH: "5 to 7",
    EC: "1.9 – 2.5 mS/cm (1200 – 1600 ppm)",
    Timer: "Timer: 15 minutes on and 3Hrs off",
    Composition: "",
  },
  {
    Day: 64,
    Activity: "Fertigation",
    pH: "5 to 7",
    EC: "1.9 – 2.5 mS/cm (1200 – 1600 ppm)",
    Timer: "Timer: 15 minutes on and 3Hrs off",
    Composition: "12:61:00 (1.5g/L) + CaNO3 (2g/L) + Boron (0.5g/L)",
  },
  {
    Day: 65,
    Activity: "",
    pH: "5 to 7",
    EC: "1.9 – 2.5 mS/cm (1200 – 1600 ppm)",
    Timer: "Timer: 15 minutes on and 3Hrs off",
    Composition: "",
  },
  {
    Day: 66,
    Activity: "",
    pH: "5 to 7",
    EC: "1.9 – 2.5 mS/cm (1200 – 1600 ppm)",
    Timer: "Timer: 15 minutes on and 3Hrs off",
    Composition: "",
  },
  {
    Day: 67,
    Activity: "",
    pH: "5 to 7",
    EC: "1.9 – 2.5 mS/cm (1200 – 1600 ppm)",
    Timer: "Timer: 15 minutes on and 3Hrs off",
    Composition: "",
  },
  {
    Day: 68,
    Activity: "Fertigation",
    pH: "5 to 7",
    EC: "1.9 – 2.5 mS/cm (1200 – 1600 ppm)",
    Timer: "Timer: 15 minutes on and 3Hrs off",
    Composition: "12:61:00 (1.5g/L) + CaNO3 (2g/L) + Boron (0.5g/L)",
  },
  {
    Day: 69,
    Activity: "",
    pH: "5 to 7",
    EC: "1.9 – 2.5 mS/cm (1200 – 1600 ppm)",
    Timer: "Timer: 15 minutes on and 3Hrs off",
    Composition: "",
  },
  {
    Day: 70,
    Activity: "",
    pH: "5 to 7",
    EC: "1.9 – 2.5 mS/cm (1200 – 1600 ppm)",
    Timer: "Timer: 15 minutes on and 3Hrs off",
    Composition: "",
  },
  {
    Day: 71,
    Activity: "Fertigation",
    pH: "5 to 7",
    EC: "1.9 – 2.5 mS/cm (1200 – 1600 ppm)",
    Timer: "Timer: 15 minutes on and 3Hrs off",
    Composition: "12:61:00 (1.5g/L) + CaNO3 (2g/L) + Boron (0.5g/L)",
  },
  {
    Day: 72,
    Activity: "",
    pH: "5 to 7",
    EC: "1.9 – 2.5 mS/cm (1200 – 1600 ppm)",
    Timer: "Timer: 15 minutes on and 3Hrs off",
    Composition: "",
  },
  {
    Day: 73,
    Activity: "",
    pH: "5 to 7",
    EC: "1.9 – 2.5 mS/cm (1200 – 1600 ppm)",
    Timer: "Timer: 15 minutes on and 3Hrs off",
    Composition: "",
  },
  {
    Day: 74,
    Activity: "Fertigation",
    pH: "5 to 7",
    EC: "1.9 – 2.5 mS/cm (1200 – 1600 ppm)",
    Timer: "Timer: 15 minutes on and 3Hrs off",
    Composition: "0:52:34 (1.5g/L) + KNO3 (1.5g/L)",
  },
  {
    Day: 75,
    Activity: "",
    pH: "5 to 7",
    EC: "1.9 – 2.5 mS/cm (1200 – 1600 ppm)",
    Timer: "Timer: 15 minutes on and 3Hrs off",
    Composition: "",
  },
  {
    Day: 76,
    Activity: "",
    pH: "5 to 7",
    EC: "1.9 – 2.5 mS/cm (1200 – 1600 ppm)",
    Timer: "Timer: 15 minutes on and 3Hrs off",
    Composition: "",
  },
  {
    Day: 77,
    Activity: "Fertigation",
    pH: "5 to 7",
    EC: "1.9 – 2.5 mS/cm (1200 – 1600 ppm)",
    Timer: "Timer: 15 minutes on and 3Hrs off",
    Composition: "0:52:34 (1.5g/L) + KNO3 (1.5g/L)",
  },
  {
    Day: 78,
    Activity: "Spray",
    pH: "5 to 7",
    EC: "1.9 – 2.5 mS/cm (1200 – 1600 ppm)",
    Timer: "Timer: 15 minutes on and 3Hrs off",
    Composition:
      "KNO3(0.5g/L) + CaNO3 (0.5g/L) (spray early morning or late evening)",
  },
  {
    Day: 79,
    Activity: "",
    pH: "5 to 7",
    EC: "1.9 – 2.5 mS/cm (1200 – 1600 ppm)",
    Timer: "Timer: 15 minutes on and 3Hrs off",
    Composition: "",
  },
  {
    Day: 80,
    Activity: "",
    pH: "5 to 7",
    EC: "1.9 – 2.5 mS/cm (1200 – 1600 ppm)",
    Timer: "Timer: 15 minutes on and 3Hrs off",
    Composition: "",
  },
  {
    Day: 81,
    Activity: "Fertigation",
    pH: "5 to 7",
    EC: "1.9 – 2.5 mS/cm (1200 – 1600 ppm)",
    Timer: "Timer: 15 minutes on and 3Hrs off",
    Composition: "0:52:34 (1.5g/L) + KNO3 (1.5g/L)",
  },
  {
    Day: 82,
    Activity: "Spray",
    pH: "5 to 7",
    EC: "1.9 – 2.5 mS/cm (1200 – 1600 ppm)",
    Timer: "Timer: 15 minutes on and 3Hrs off",
    Composition: "Sulphur (1.8g/L) (spray early morning or late evening)",
  },
  {
    Day: 83,
    Activity: "",
    pH: "5 to 7",
    EC: "1.9 – 2.5 mS/cm (1200 – 1600 ppm)",
    Timer: "Timer: 15 minutes on and 3Hrs off",
    Composition: "",
  },
  {
    Day: 84,
    Activity: "",
    pH: "5 to 7",
    EC: "1.9 – 2.5 mS/cm (1200 – 1600 ppm)",
    Timer: "Timer: 15 minutes on and 3Hrs off",
    Composition: "",
  },
  {
    Day: 85,
    Activity: "Fertigation",
    pH: "5 to 7",
    EC: "1.9 – 2.5 mS/cm (1200 – 1600 ppm)",
    Timer: "Timer: 15 minutes on and 3Hrs off",
    Composition: "0:52:34 (1.5g/L) + KNO3 (1.5g/L)",
  },
  {
    Day: 86,
    Activity: "",
    pH: "5 to 7",
    EC: "1.9 – 2.5 mS/cm (1200 – 1600 ppm)",
    Timer: "Timer: 15 minutes on and 3Hrs off",
    Composition: "",
  },
  {
    Day: 87,
    Activity: "",
    pH: "5 to 7",
    EC: "1.9 – 2.5 mS/cm (1200 – 1600 ppm)",
    Timer: "Timer: 15 minutes on and 3Hrs off",
    Composition: "",
  },
  {
    Day: 88,
    Activity: "Fertigation",
    pH: "5 to 7",
    EC: "1.9 – 2.5 mS/cm (1200 – 1600 ppm)",
    Timer: "Timer: 15 minutes on and 3Hrs off",
    Composition: "0:52:34 (1.5g/L) + KNO3 (1.5g/L)",
  },
  {
    Day: 89,
    Activity: "",
    pH: "5 to 7",
    EC: "1.9 – 2.5 mS/cm (1200 – 1600 ppm)",
    Timer: "Timer: 15 minutes on and 3Hrs off",
    Composition: "",
  },
  {
    Day: 90,
    Activity: "Drenching",
    pH: "5 to 7",
    EC: "1.9 – 2.5 mS/cm (1200 – 1600 ppm)",
    Timer: "Timer: 15 minutes on and 3Hrs off",
    Composition: "Trichoderma + Pseudomonas (1.5ml/L)",
  },
  {
    Day: 91,
    Activity: "",
    pH: "5 to 7",
    EC: "1.9 – 2.5 mS/cm (1200 – 1600 ppm)",
    Timer: "Timer: 15 minutes on and 3Hrs off",
    Composition: "",
  },
  {
    Day: 92,
    Activity: "",
    pH: "5 to 7",
    EC: "1.9 – 2.5 mS/cm (1200 – 1600 ppm)",
    Timer: "Timer: 15 minutes on and 3Hrs off",
    Composition: "",
  },
  {
    Day: 93,
    Activity: "Fertigation",
    pH: "5 to 7",
    EC: "1.9 – 2.5 mS/cm (1200 – 1600 ppm)",
    Timer: "Timer: 15 minutes on and 3Hrs off",
    Composition: "0:52:34 (1.5g/L) + KNO3 (1.5g/L)",
  },
  {
    Day: 94,
    Activity: "",
    pH: "5 to 7",
    EC: "1.9 – 2.5 mS/cm (1200 – 1600 ppm)",
    Timer: "Timer: 15 minutes on and 3Hrs off",
    Composition: "",
  },
  {
    Day: 95,
    Activity: "Spray",
    pH: "5 to 7",
    EC: "1.9 – 2.5 mS/cm (1200 – 1600 ppm)",
    Timer: "Timer: 15 minutes on and 3Hrs off",
    Composition:
      "Micronutrient mix (1g/L) (spray early morning or late evening)",
  },
  {
    Day: 96,
    Activity: "",
    pH: "5 to 7",
    EC: "1.9 – 2.5 mS/cm (1200 – 1600 ppm)",
    Timer: "Timer: 15 minutes on and 3Hrs off",
    Composition: "",
  },
  {
    Day: 97,
    Activity: "Fertigation",
    pH: "5 to 7",
    EC: "1.9 – 2.5 mS/cm (1200 – 1600 ppm)",
    Timer: "Timer: 15 minutes on and 3Hrs off",
    Composition: "0:52:34 (1.5g/L) + KNO3 (1.5g/L)",
  },
  {
    Day: 98,
    Activity: "",
    pH: "5 to 7",
    EC: "1.9 – 2.5 mS/cm (1200 – 1600 ppm)",
    Timer: "Timer: 15 minutes on and 3Hrs off",
    Composition: "",
  },
  {
    Day: 99,
    Activity: "",
    pH: "5 to 7",
    EC: "1.9 – 2.5 mS/cm (1200 – 1600 ppm)",
    Timer: "Timer: 15 minutes on and 3Hrs off",
    Composition: "",
  },
  {
    Day: 100,
    Activity: "Fertigation",
    pH: "5 to 7",
    EC: "1.9 – 2.5 mS/cm (1200 – 1600 ppm)",
    Timer: "Timer: 15 minutes on and 3Hrs off",
    Composition: "0:52:34 (1.5g/L) + KNO3 (1.5g/L)",
  },
  {
    Day: 101,
    Activity: "",
    pH: "5 to 7",
    EC: "1.9 – 2.5 mS/cm (1200 – 1600 ppm)",
    Timer: "Timer: 15 minutes on and 3Hrs off",
    Composition: "",
  },
  {
    Day: 102,
    Activity: "",
    pH: "5 to 7",
    EC: "1.9 – 2.5 mS/cm (1200 – 1600 ppm)",
    Timer: "Timer: 15 minutes on and 3Hrs off",
    Composition: "",
  },
  {
    Day: 103,
    Activity: "Fertigation",
    pH: "5 to 7",
    EC: "1.9 – 2.5 mS/cm (1200 – 1600 ppm)",
    Timer: "Timer: 15 minutes on and 3Hrs off",
    Composition: "0:52:34 (1.5g/L) + KNO3 (1.5g/L)",
  },
  {
    Day: 104,
    Activity: "",
    pH: "5 to 7",
    EC: "1.9 – 2.5 mS/cm (1200 – 1600 ppm)",
    Timer: "Timer: 15 minutes on and 3Hrs off",
    Composition: "",
  },
  {
    Day: 105,
    Activity: "",
    pH: "5 to 7",
    EC: "1.9 – 2.5 mS/cm (1200 – 1600 ppm)",
    Timer: "Timer: 15 minutes on and 3Hrs off",
    Composition: "",
  },
  {
    Day: 106,
    Activity: "Fertigation",
    pH: "5 to 7",
    EC: "1.9 – 2.5 mS/cm (1200 – 1600 ppm)",
    Timer: "Timer: 15 minutes on and 3Hrs off",
    Composition: "0:52:34 (1.5g/L) + KNO3 (1.5g/L)",
  },
  {
    Day: 107,
    Activity: "",
    pH: "5 to 7",
    EC: "1.9 – 2.5 mS/cm (1200 – 1600 ppm)",
    Timer: "Timer: 15 minutes on and 3Hrs off",
    Composition: "",
  },
  {
    Day: 108,
    Activity: "",
    pH: "5 to 7",
    EC: "1.9 – 2.5 mS/cm (1200 – 1600 ppm)",
    Timer: "Timer: 15 minutes on and 3Hrs off",
    Composition: "",
  },
  {
    Day: 109,
    Activity: "Fertigation",
    pH: "5 to 7",
    EC: "1.9 – 2.5 mS/cm (1200 – 1600 ppm)",
    Timer: "Timer: 15 minutes on and 3Hrs off",
    Composition: "0:52:34 (1.5g/L) + KNO3 (1.5g/L)",
  },
  {
    Day: 110,
    Activity: "",
    pH: "5 to 7",
    EC: "1.9 – 2.5 mS/cm (1200 – 1600 ppm)",
    Timer: "Timer: 15 minutes on and 3Hrs off",
    Composition: "",
  },
  {
    Day: 111,
    Activity: "",
    pH: "5 to 7",
    EC: "1.9 – 2.5 mS/cm (1200 – 1600 ppm)",
    Timer: "Timer: 15 minutes on and 3Hrs off",
    Composition: "",
  },
  {
    Day: 112,
    Activity: "Fertigation",
    pH: "5 to 7",
    EC: "1.9 – 2.5 mS/cm (1200 – 1600 ppm)",
    Timer: "Timer: 15 minutes on and 3Hrs off",
    Composition: "0:52:34 (1.5g/L) + KNO3 (1.5g/L)",
  },
  {
    Day: 113,
    Activity: "",
    pH: "5 to 7",
    EC: "1.9 – 2.5 mS/cm (1200 – 1600 ppm)",
    Timer: "Timer: 15 minutes on and 3Hrs off",
    Composition: "",
  },
  {
    Day: 114,
    Activity: "",
    pH: "5 to 7",
    EC: "1.9 – 2.5 mS/cm (1200 – 1600 ppm)",
    Timer: "Timer: 15 minutes on and 3Hrs off",
    Composition: "",
  },
  {
    Day: 115,
    Activity: "Fertigation",
    pH: "5 to 7",
    EC: "1.9 – 2.5 mS/cm (1200 – 1600 ppm)",
    Timer: "Timer: 15 minutes on and 3Hrs off",
    Composition: "0:52:34 (1.5g/L) + KNO3 (1.5g/L)",
  },
  {
    Day: 116,
    Activity: "",
    pH: "5 to 7",
    EC: "1.9 – 2.5 mS/cm (1200 – 1600 ppm)",
    Timer: "Timer: 15 minutes on and 3Hrs off",
    Composition: "",
  },
  {
    Day: 117,
    Activity: "",
    pH: "5 to 7",
    EC: "1.9 – 2.5 mS/cm (1200 – 1600 ppm)",
    Timer: "Timer: 15 minutes on and 3Hrs off",
    Composition: "",
  },
  {
    Day: 118,
    Activity: "Fertigation",
    pH: "5 to 7",
    EC: "1.9 – 2.5 mS/cm (1200 – 1600 ppm)",
    Timer: "Timer: 15 minutes on and 3Hrs off",
    Composition: "0:52:34 (1.5g/L) + KNO3 (1.5g/L)",
  },
  {
    Day: 119,
    Activity: "",
    pH: "5 to 7",
    EC: "1.9 – 2.5 mS/cm (1200 – 1600 ppm)",
    Timer: "Timer: 15 minutes on and 3Hrs off",
    Composition: "",
  },
  {
    Day: 120,
    Activity: "",
    pH: "5 to 7",
    EC: "1.9 – 2.5 mS/cm (1200 – 1600 ppm)",
    Timer: "Timer: 15 minutes on and 3Hrs off",
    Composition: "",
  },
];
let nftSingleCycle = [
  {
    Day: 1,
    EC: "0.8 – 1.0 mS/cm (512 – 640 ppm)",
    pH: "5 to 7",
    Timer: "Timer: 30 minutes on and 3Hrs off",
    tankMaintenance: "",
    spraySchedule: "",
  },
  {
    Day: 2,
    EC: "0.8 – 1.0 mS/cm (512 – 640 ppm)",
    pH: "5 to 7",
    Timer: "Timer: 30 minutes on and 3Hrs off",
    tankMaintenance: "",
    spraySchedule: "",
  },
  {
    Day: 3,
    EC: "0.8 – 1.0 mS/cm (512 – 640 ppm)",
    pH: "5 to 7",
    Timer: "Timer: 30 minutes on and 3Hrs off",
    tankMaintenance: "",
    spraySchedule: "",
  },
  {
    Day: 4,
    EC: "0.8 – 1.0 mS/cm (512 – 640 ppm)",
    pH: "5 to 7",
    Timer: "Timer: 30 minutes on and 3Hrs off",
    tankMaintenance: "",
    spraySchedule: "",
  },
  {
    Day: 5,
    EC: "0.8 – 1.0 mS/cm (512 – 640 ppm)",
    pH: "5 to 7",
    Timer: "Timer: 30 minutes on and 3Hrs off",
    tankMaintenance: "",
    spraySchedule: "",
  },
  {
    Day: 6,
    EC: "0.8 – 1.0 mS/cm (512 – 640 ppm)",
    pH: "5 to 7",
    Timer: "Timer: 30 minutes on and 3Hrs off",
    tankMaintenance: "",
    spraySchedule: "",
  },
  {
    Day: 7,
    EC: "0.8 – 1.0 mS/cm (512 – 640 ppm)",
    pH: "5 to 7",
    Timer: "Timer: 30 minutes on and 3Hrs off",
    tankMaintenance: "Flush & refill nutrients",
    spraySchedule: "",
  },
  {
    Day: 8,
    EC: "1.2 – 1.6 mS/cm (800 – 1000 ppm)",
    pH: "5 to 7",
    Timer: "Timer: 30 minutes on and 3Hrs off",
    tankMaintenance: "",
    spraySchedule: "",
  },
  {
    Day: 9,
    EC: "1.2 – 1.6 mS/cm (800 – 1000 ppm)",
    pH: "5 to 7",
    Timer: "Timer: 30 minutes on and 3Hrs off",
    tankMaintenance: "",
    spraySchedule: "",
  },
  {
    Day: 10,
    EC: "1.2 – 1.6 mS/cm (800 – 1000 ppm)",
    pH: "5 to 7",
    Timer: "Timer: 30 minutes on and 3Hrs off",
    tankMaintenance: "",
    spraySchedule: "Neem Oil 1500 ppm (5ml/L) + sticker",
  },
  {
    Day: 11,
    EC: "1.2 – 1.6 mS/cm (800 – 1000 ppm)",
    pH: "5 to 7",
    Timer: "Timer: 30 minutes on and 3Hrs off",
    tankMaintenance: "",
    spraySchedule: "",
  },
  {
    Day: 12,
    EC: "1.2 – 1.6 mS/cm (800 – 1000 ppm)",
    pH: "5 to 7",
    Timer: "Timer: 30 minutes on and 3Hrs off",
    tankMaintenance: "",
    spraySchedule: "Micronutrient Spray (2ml/L)",
  },
  {
    Day: 13,
    EC: "1.2 – 1.6 mS/cm (800 – 1000 ppm)",
    pH: "5 to 7",
    Timer: "Timer: 30 minutes on and 3Hrs off",
    tankMaintenance: "",
    spraySchedule: "",
  },
  {
    Day: 14,
    EC: "1.2 – 1.6 mS/cm (800 – 1000 ppm)",
    pH: "5 to 7",
    Timer: "Timer: 30 minutes on and 3Hrs off",
    tankMaintenance: "Flush & refill nutrients",
    spraySchedule: "",
  },
  {
    Day: 15,
    EC: "1.2 – 1.6 mS/cm (800 – 1000 ppm)",
    pH: "5 to 7",
    Timer: "Timer: 30 minutes on and 3Hrs off",
    tankMaintenance: "",
    spraySchedule: "Bt Spray (2ml/L) or Trichoderma (2ml/L)",
  },
  {
    Day: 16,
    EC: "1.2 – 1.6 mS/cm (800 – 1000 ppm)",
    pH: "5 to 7",
    Timer: "Timer: 30 minutes on and 3Hrs off",
    tankMaintenance: "",
    spraySchedule: "",
  },
  {
    Day: 17,
    EC: "1.2 – 1.6 mS/cm (800 – 1000 ppm)",
    pH: "5 to 7",
    Timer: "Timer: 30 minutes on and 3Hrs off",
    tankMaintenance: "",
    spraySchedule: "",
  },
  {
    Day: 18,
    EC: "1.2 – 1.6 mS/cm (800 – 1000 ppm)",
    pH: "5 to 7",
    Timer: "Timer: 30 minutes on and 3Hrs off",
    tankMaintenance: "",
    spraySchedule: "",
  },
  {
    Day: 19,
    EC: "1.2 – 1.6 mS/cm (800 – 1000 ppm)",
    pH: "5 to 7",
    Timer: "Timer: 30 minutes on and 3Hrs off",
    tankMaintenance: "",
    spraySchedule: "",
  },
  {
    Day: 20,
    EC: "1.2 – 1.6 mS/cm (800 – 1000 ppm)",
    pH: "5 to 7",
    Timer: "Timer: 30 minutes on and 3Hrs off",
    tankMaintenance: "",
    spraySchedule: "Neem Oil 1500 ppm (5ml/L) + sticker",
  },
  {
    Day: 21,
    EC: "1.6 – 1.8 mS/cm (1000 – 1200 ppm)",
    pH: "5 to 7",
    Timer: "Timer: 30 minutes on and 3Hrs off",
    tankMaintenance: "Flush & refill nutrients",
    spraySchedule: "",
  },
  {
    Day: 22,
    EC: "1.6 – 1.8 mS/cm (1000 – 1200 ppm)",
    pH: "5 to 7",
    Timer: "Timer: 30 minutes on and 3Hrs off",
    tankMaintenance: "",
    spraySchedule: "Micronutrient Spray (2ml/L)",
  },
  {
    Day: 23,
    EC: "1.6 – 1.8 mS/cm (1000 – 1200 ppm)",
    pH: "5 to 7",
    Timer: "Timer: 30 minutes on and 3Hrs off",
    tankMaintenance: "",
    spraySchedule: "",
  },
  {
    Day: 24,
    EC: "1.6 – 1.8 mS/cm (1000 – 1200 ppm)",
    pH: "5 to 7",
    Timer: "Timer: 30 minutes on and 3Hrs off",
    tankMaintenance: "",
    spraySchedule: "",
  },
  {
    Day: 25,
    EC: "1.6 – 1.8 mS/cm (1000 – 1200 ppm)",
    pH: "5 to 7",
    Timer: "Timer: 30 minutes on and 3Hrs off",
    tankMaintenance: "",
    spraySchedule: "",
  },
  {
    Day: 26,
    EC: "1.6 – 1.8 mS/cm (1000 – 1200 ppm)",
    pH: "5 to 7",
    Timer: "Timer: 30 minutes on and 3Hrs off",
    tankMaintenance: "",
    spraySchedule: "",
  },
  {
    Day: 27,
    EC: "1.6 – 1.8 mS/cm (1000 – 1200 ppm)",
    pH: "5 to 7",
    Timer: "Timer: 30 minutes on and 3Hrs off",
    tankMaintenance: "",
    spraySchedule: "",
  },
  {
    Day: 28,
    EC: "1.6 – 1.8 mS/cm (1000 – 1200 ppm)",
    pH: "5 to 7",
    Timer: "Timer: 30 minutes on and 3Hrs off",
    tankMaintenance: "Flush & refill nutrients",
    spraySchedule: "Micronutrient Spray (2ml/L)",
  },
  {
    Day: 29,
    EC: "1.6 – 1.8 mS/cm (1000 – 1200 ppm)",
    pH: "5 to 7",
    Timer: "Timer: 30 minutes on and 3Hrs off",
    tankMaintenance: "",
    spraySchedule: "",
  },
  {
    Day: 30,
    EC: "1.6 – 1.8 mS/cm (1000 – 1200 ppm)",
    pH: "5 to 7",
    Timer: "Timer: 30 minutes on and 3Hrs off",
    tankMaintenance: "",
    spraySchedule: "Potassium Bicarbonate (3g/L)",
  },
];
let nftHerbs = [
  {
    Day: 1,
    EC: "0.8 – 1.0 mS/cm (512 – 640 ppm)",
    pH: "5 to 7",
    Timer: "Timer: 30 minutes on and 3Hrs off",
    tankMaintenance: "",
    spraySchedule: "",
  },
  {
    Day: 2,
    EC: "0.8 – 1.0 mS/cm (512 – 640 ppm)",
    pH: "5 to 7",
    Timer: "Timer: 30 minutes on and 3Hrs off",
    tankMaintenance: "",
    spraySchedule: "",
  },
  {
    Day: 3,
    EC: "0.8 – 1.0 mS/cm (512 – 640 ppm)",
    pH: "5 to 7",
    Timer: "Timer: 30 minutes on and 3Hrs off",
    tankMaintenance: "",
    spraySchedule: "",
  },
  {
    Day: 4,
    EC: "0.8 – 1.0 mS/cm (512 – 640 ppm)",
    pH: "5 to 7",
    Timer: "Timer: 30 minutes on and 3Hrs off",
    tankMaintenance: "",
    spraySchedule: "",
  },
  {
    Day: 5,
    EC: "0.8 – 1.0 mS/cm (512 – 640 ppm)",
    pH: "5 to 7",
    Timer: "Timer: 30 minutes on and 3Hrs off",
    tankMaintenance: "",
    spraySchedule: "",
  },
  {
    Day: 6,
    EC: "0.8 – 1.0 mS/cm (512 – 640 ppm)",
    pH: "5 to 7",
    Timer: "Timer: 30 minutes on and 3Hrs off",
    tankMaintenance: "",
    spraySchedule: "",
  },
  {
    Day: 7,
    EC: "0.8 – 1.0 mS/cm (512 – 640 ppm)",
    pH: "5 to 7",
    Timer: "Timer: 30 minutes on and 3Hrs off",
    tankMaintenance: "Flush & refill nutrients",
    spraySchedule: "",
  },
  {
    Day: 8,
    EC: "1.2 – 1.6 mS/cm (800 – 1000 ppm)",
    pH: "5 to 7",
    Timer: "Timer: 30 minutes on and 3Hrs off",
    tankMaintenance: "",
    spraySchedule: "Neem Oil 1500 ppm (5ml/L) + sticker",
  },
  {
    Day: 9,
    EC: "1.2 – 1.6 mS/cm (800 – 1000 ppm)",
    pH: "5 to 7",
    Timer: "Timer: 30 minutes on and 3Hrs off",
    tankMaintenance: "",
    spraySchedule: "",
  },
  {
    Day: 10,
    EC: "1.2 – 1.6 mS/cm (800 – 1000 ppm)",
    pH: "5 to 7",
    Timer: "Timer: 30 minutes on and 3Hrs off",
    tankMaintenance: "",
    spraySchedule: "",
  },
  {
    Day: 11,
    EC: "1.2 – 1.6 mS/cm (800 – 1000 ppm)",
    pH: "5 to 7",
    Timer: "Timer: 30 minutes on and 3Hrs off",
    tankMaintenance: "",
    spraySchedule: "",
  },
  {
    Day: 12,
    EC: "1.2 – 1.6 mS/cm (800 – 1000 ppm)",
    pH: "5 to 7",
    Timer: "Timer: 30 minutes on and 3Hrs off",
    tankMaintenance: "",
    spraySchedule: "Micronutrient Spray (2ml/L)",
  },
  {
    Day: 13,
    EC: "1.2 – 1.6 mS/cm (800 – 1000 ppm)",
    pH: "5 to 7",
    Timer: "Timer: 30 minutes on and 3Hrs off",
    tankMaintenance: "",
    spraySchedule: "",
  },
  {
    Day: 14,
    EC: "1.2 – 1.6 mS/cm (800 – 1000 ppm)",
    pH: "5 to 7",
    Timer: "Timer: 30 minutes on and 3Hrs off",
    tankMaintenance: "Flush & refill nutrients",
    spraySchedule: "",
  },
  {
    Day: 15,
    EC: "1.2 – 1.6 mS/cm (800 – 1000 ppm)",
    pH: "5 to 7",
    Timer: "Timer: 30 minutes on and 3Hrs off",
    tankMaintenance: "",
    spraySchedule: "Bt Spray (2ml/L) or Trichoderma (2ml/L)",
  },
  {
    Day: 16,
    EC: "1.2 – 1.6 mS/cm (800 – 1000 ppm)",
    pH: "5 to 7",
    Timer: "Timer: 30 minutes on and 3Hrs off",
    tankMaintenance: "",
    spraySchedule: "",
  },
  {
    Day: 17,
    EC: "1.2 – 1.6 mS/cm (800 – 1000 ppm)",
    pH: "5 to 7",
    Timer: "Timer: 30 minutes on and 3Hrs off",
    tankMaintenance: "",
    spraySchedule: "",
  },
  {
    Day: 18,
    EC: "1.2 – 1.6 mS/cm (800 – 1000 ppm)",
    pH: "5 to 7",
    Timer: "Timer: 30 minutes on and 3Hrs off",
    tankMaintenance: "",
    spraySchedule: "",
  },
  {
    Day: 19,
    EC: "1.2 – 1.6 mS/cm (800 – 1000 ppm)",
    pH: "5 to 7",
    Timer: "Timer: 30 minutes on and 3Hrs off",
    tankMaintenance: "",
    spraySchedule: "Micronutrient Spray (2ml/L)",
  },
  {
    Day: 20,
    EC: "1.2 – 1.6 mS/cm (800 – 1000 ppm)",
    pH: "5 to 7",
    Timer: "Timer: 30 minutes on and 3Hrs off",
    tankMaintenance: "",
    spraySchedule: "",
  },
  {
    Day: 21,
    EC: "1.6 – 1.8 mS/cm (1000 – 1200 ppm)",
    pH: "5 to 7",
    Timer: "Timer: 30 minutes on and 3Hrs off",
    tankMaintenance: "Flush & refill nutrients",
    spraySchedule: "",
  },
  {
    Day: 22,
    EC: "1.6 – 1.8 mS/cm (1000 – 1200 ppm)",
    pH: "5 to 7",
    Timer: "Timer: 30 minutes on and 3Hrs off",
    tankMaintenance: "",
    spraySchedule: "Neem Oil 1500 ppm (5ml/L) + sticker",
  },
  {
    Day: 23,
    EC: "1.6 – 1.8 mS/cm (1000 – 1200 ppm)",
    pH: "5 to 7",
    Timer: "Timer: 30 minutes on and 3Hrs off",
    tankMaintenance: "",
    spraySchedule: "",
  },
  {
    Day: 24,
    EC: "1.6 – 1.8 mS/cm (1000 – 1200 ppm)",
    pH: "5 to 7",
    Timer: "Timer: 30 minutes on and 3Hrs off",
    tankMaintenance: "",
    spraySchedule: "",
  },
  {
    Day: 25,
    EC: "1.6 – 1.8 mS/cm (1000 – 1200 ppm)",
    pH: "5 to 7",
    Timer: "Timer: 30 minutes on and 3Hrs off",
    tankMaintenance: "",
    spraySchedule: "",
  },
  {
    Day: 26,
    EC: "1.6 – 1.8 mS/cm (1000 – 1200 ppm)",
    pH: "5 to 7",
    Timer: "Timer: 30 minutes on and 3Hrs off",
    tankMaintenance: "",
    spraySchedule: "Micronutrient Spray (2ml/L)",
  },
  {
    Day: 27,
    EC: "1.6 – 1.8 mS/cm (1000 – 1200 ppm)",
    pH: "5 to 7",
    Timer: "Timer: 30 minutes on and 3Hrs off",
    tankMaintenance: "",
    spraySchedule: "",
  },
  {
    Day: 28,
    EC: "1.6 – 1.8 mS/cm (1000 – 1200 ppm)",
    pH: "5 to 7",
    Timer: "Timer: 30 minutes on and 3Hrs off",
    tankMaintenance: "",
    spraySchedule: "",
  },
  {
    Day: 29,
    EC: "1.6 – 1.8 mS/cm (1000 – 1200 ppm)",
    pH: "5 to 7",
    Timer: "Timer: 30 minutes on and 3Hrs off",
    tankMaintenance: "",
    spraySchedule: "",
  },
  {
    Day: 30,
    EC: "1.6 – 1.8 mS/cm (1000 – 1200 ppm)",
    pH: "5 to 7",
    Timer: "Timer: 30 minutes on and 3Hrs off",
    tankMaintenance: "",
    spraySchedule: "",
  },
  {
    Day: 31,
    EC: "1.6 – 1.8 mS/cm (1000 – 1200 ppm)",
    pH: "5 to 7",
    Timer: "Timer: 30 minutes on and 3Hrs off",
    tankMaintenance: "",
    spraySchedule: "",
  },
  {
    Day: 32,
    EC: "1.6 – 1.8 mS/cm (1000 – 1200 ppm)",
    pH: "5 to 7",
    Timer: "Timer: 30 minutes on and 3Hrs off",
    tankMaintenance: "",
    spraySchedule: "Potassium Bicarbonate (3g/L)",
  },
  {
    Day: 33,
    EC: "1.6 – 1.8 mS/cm (1000 – 1200 ppm)",
    pH: "5 to 7",
    Timer: "Timer: 30 minutes on and 3Hrs off",
    tankMaintenance: "",
    spraySchedule: "",
  },
  {
    Day: 34,
    EC: "1.6 – 1.8 mS/cm (1000 – 1200 ppm)",
    pH: "5 to 7",
    Timer: "Timer: 30 minutes on and 3Hrs off",
    tankMaintenance: "",
    spraySchedule: "",
  },
  {
    Day: 35,
    EC: "1.6 – 1.8 mS/cm (1000 – 1200 ppm)",
    pH: "5 to 7",
    Timer: "Timer: 30 minutes on and 3Hrs off",
    tankMaintenance: "",
    spraySchedule: "",
  },
  {
    Day: 36,
    EC: "1.6 – 1.8 mS/cm (1000 – 1200 ppm)",
    pH: "5 to 7",
    Timer: "Timer: 30 minutes on and 3Hrs off",
    tankMaintenance: "",
    spraySchedule: "",
  },
  {
    Day: 37,
    EC: "1.6 – 1.8 mS/cm (1000 – 1200 ppm)",
    pH: "5 to 7",
    Timer: "Timer: 30 minutes on and 3Hrs off",
    tankMaintenance: "",
    spraySchedule: "",
  },
  {
    Day: 38,
    EC: "1.6 – 1.8 mS/cm (1000 – 1200 ppm)",
    pH: "5 to 7",
    Timer: "Timer: 30 minutes on and 3Hrs off",
    tankMaintenance: "",
    spraySchedule: "",
  },
  {
    Day: 39,
    EC: "1.6 – 1.8 mS/cm (1000 – 1200 ppm)",
    pH: "5 to 7",
    Timer: "Timer: 30 minutes on and 3Hrs off",
    tankMaintenance: "",
    spraySchedule: "",
  },
  {
    Day: 40,
    EC: "1.6 – 1.8 mS/cm (1000 – 1200 ppm)",
    pH: "5 to 7",
    Timer: "Timer: 30 minutes on and 3Hrs off",
    tankMaintenance: "Flush & refill nutrients",
    spraySchedule: "",
  },
  {
    Day: 41,
    EC: "1.6 – 1.8 mS/cm (1000 – 1200 ppm)",
    pH: "5 to 7",
    Timer: "Timer: 30 minutes on and 3Hrs off",
    tankMaintenance: "",
    spraySchedule: "Bt Spray (2ml/L) or Trichoderma (2ml/L)",
  },
  {
    Day: 42,
    EC: "1.6 – 1.8 mS/cm (1000 – 1200 ppm)",
    pH: "5 to 7",
    Timer: "Timer: 30 minutes on and 3Hrs off",
    tankMaintenance: "",
    spraySchedule: "",
  },
  {
    Day: 43,
    EC: "1.6 – 1.8 mS/cm (1000 – 1200 ppm)",
    pH: "5 to 7",
    Timer: "Timer: 30 minutes on and 3Hrs off",
    tankMaintenance: "",
    spraySchedule: "",
  },
  {
    Day: 44,
    EC: "1.6 – 1.8 mS/cm (1000 – 1200 ppm)",
    pH: "5 to 7",
    Timer: "Timer: 30 minutes on and 3Hrs off",
    tankMaintenance: "",
    spraySchedule: "",
  },
  {
    Day: 45,
    EC: "1.6 – 1.8 mS/cm (1000 – 1200 ppm)",
    pH: "5 to 7",
    Timer: "Timer: 30 minutes on and 3Hrs off",
    tankMaintenance: "",
    spraySchedule: "",
  },
  {
    Day: 46,
    EC: "1.6 – 1.8 mS/cm (1000 – 1200 ppm)",
    pH: "5 to 7",
    Timer: "Timer: 30 minutes on and 3Hrs off",
    tankMaintenance: "",
    spraySchedule: "Micronutrient Spray (2ml/L)",
  },
  {
    Day: 47,
    EC: "1.6 – 1.8 mS/cm (1000 – 1200 ppm)",
    pH: "5 to 7",
    Timer: "Timer: 30 minutes on and 3Hrs off",
    tankMaintenance: "",
    spraySchedule: "",
  },
  {
    Day: 48,
    EC: "1.6 – 1.8 mS/cm (1000 – 1200 ppm)",
    pH: "5 to 7",
    Timer: "Timer: 30 minutes on and 3Hrs off",
    tankMaintenance: "",
    spraySchedule: "",
  },
  {
    Day: 49,
    EC: "1.6 – 1.8 mS/cm (1000 – 1200 ppm)",
    pH: "5 to 7",
    Timer: "Timer: 30 minutes on and 3Hrs off",
    tankMaintenance: "",
    spraySchedule: "",
  },
  {
    Day: 50,
    EC: "1.6 – 1.8 mS/cm (1000 – 1200 ppm)",
    pH: "5 to 7",
    Timer: "Timer: 30 minutes on and 3Hrs off",
    tankMaintenance: "",
    spraySchedule: "",
  },
  {
    Day: 51,
    EC: "1.6 – 1.8 mS/cm (1000 – 1200 ppm)",
    pH: "5 to 7",
    Timer: "Timer: 30 minutes on and 3Hrs off",
    tankMaintenance: "",
    spraySchedule: "",
  },
  {
    Day: 52,
    EC: "1.6 – 1.8 mS/cm (1000 – 1200 ppm)",
    pH: "5 to 7",
    Timer: "Timer: 30 minutes on and 3Hrs off",
    tankMaintenance: "",
    spraySchedule: "Potassium Bicarbonate (3g/L)",
  },
  {
    Day: 53,
    EC: "1.6 – 1.8 mS/cm (1000 – 1200 ppm)",
    pH: "5 to 7",
    Timer: "Timer: 30 minutes on and 3Hrs off",
    tankMaintenance: "",
    spraySchedule: "",
  },
  {
    Day: 54,
    EC: "1.6 – 1.8 mS/cm (1000 – 1200 ppm)",
    pH: "5 to 7",
    Timer: "Timer: 30 minutes on and 3Hrs off",
    tankMaintenance: "",
    spraySchedule: "",
  },
  {
    Day: 55,
    EC: "1.6 – 1.8 mS/cm (1000 – 1200 ppm)",
    pH: "5 to 7",
    Timer: "Timer: 30 minutes on and 3Hrs off",
    tankMaintenance: "",
    spraySchedule: "",
  },
  {
    Day: 56,
    EC: "1.6 – 1.8 mS/cm (1000 – 1200 ppm)",
    pH: "5 to 7",
    Timer: "Timer: 30 minutes on and 3Hrs off",
    tankMaintenance: "",
    spraySchedule: "",
  },
  {
    Day: 57,
    EC: "1.6 – 1.8 mS/cm (1000 – 1200 ppm)",
    pH: "5 to 7",
    Timer: "Timer: 30 minutes on and 3Hrs off",
    tankMaintenance: "",
    spraySchedule: "",
  },
  {
    Day: 58,
    EC: "1.6 – 1.8 mS/cm (1000 – 1200 ppm)",
    pH: "5 to 7",
    Timer: "Timer: 30 minutes on and 3Hrs off",
    tankMaintenance: "",
    spraySchedule: "",
  },
  {
    Day: 59,
    EC: "1.6 – 1.8 mS/cm (1000 – 1200 ppm)",
    pH: "5 to 7",
    Timer: "Timer: 30 minutes on and 3Hrs off",
    tankMaintenance: "",
    spraySchedule: "",
  },
  {
    Day: 60,
    EC: "1.6 – 1.8 mS/cm (1000 – 1200 ppm)",
    pH: "5 to 7",
    Timer: "Timer: 30 minutes on and 3Hrs off",
    tankMaintenance: "Flush & refill nutrients",
    spraySchedule: "",
  },
  {
    Day: 61,
    EC: "1.6 – 1.8 mS/cm (1000 – 1200 ppm)",
    pH: "5 to 7",
    Timer: "Timer: 30 minutes on and 3Hrs off",
    tankMaintenance: "",
    spraySchedule: "Neem Oil 1500 ppm (5ml/L) + sticker",
  },
  {
    Day: 62,
    EC: "1.6 – 1.8 mS/cm (1000 – 1200 ppm)",
    pH: "5 to 7",
    Timer: "Timer: 30 minutes on and 3Hrs off",
    tankMaintenance: "",
    spraySchedule: "",
  },
  {
    Day: 63,
    EC: "1.6 – 1.8 mS/cm (1000 – 1200 ppm)",
    pH: "5 to 7",
    Timer: "Timer: 30 minutes on and 3Hrs off",
    tankMaintenance: "",
    spraySchedule: "",
  },
  {
    Day: 64,
    EC: "1.6 – 1.8 mS/cm (1000 – 1200 ppm)",
    pH: "5 to 7",
    Timer: "Timer: 30 minutes on and 3Hrs off",
    tankMaintenance: "",
    spraySchedule: "",
  },
  {
    Day: 65,
    EC: "1.6 – 1.8 mS/cm (1000 – 1200 ppm)",
    pH: "5 to 7",
    Timer: "Timer: 30 minutes on and 3Hrs off",
    tankMaintenance: "",
    spraySchedule: "Micronutrient Spray (2ml/L)",
  },
  {
    Day: 66,
    EC: "1.6 – 1.8 mS/cm (1000 – 1200 ppm)",
    pH: "5 to 7",
    Timer: "Timer: 30 minutes on and 3Hrs off",
    tankMaintenance: "",
    spraySchedule: "",
  },
  {
    Day: 67,
    EC: "1.6 – 1.8 mS/cm (1000 – 1200 ppm)",
    pH: "5 to 7",
    Timer: "Timer: 30 minutes on and 3Hrs off",
    tankMaintenance: "",
    spraySchedule: "",
  },
  {
    Day: 68,
    EC: "1.6 – 1.8 mS/cm (1000 – 1200 ppm)",
    pH: "5 to 7",
    Timer: "Timer: 30 minutes on and 3Hrs off",
    tankMaintenance: "",
    spraySchedule: "",
  },
  {
    Day: 69,
    EC: "1.6 – 1.8 mS/cm (1000 – 1200 ppm)",
    pH: "5 to 7",
    Timer: "Timer: 30 minutes on and 3Hrs off",
    tankMaintenance: "",
    spraySchedule: "",
  },
  {
    Day: 70,
    EC: "1.6 – 1.8 mS/cm (1000 – 1200 ppm)",
    pH: "5 to 7",
    Timer: "Timer: 30 minutes on and 3Hrs off",
    tankMaintenance: "",
    spraySchedule: "",
  },
  {
    Day: 71,
    EC: "1.6 – 1.8 mS/cm (1000 – 1200 ppm)",
    pH: "5 to 7",
    Timer: "Timer: 30 minutes on and 3Hrs off",
    tankMaintenance: "",
    spraySchedule: "Potassium Bicarbonate (3g/L)",
  },
  {
    Day: 72,
    EC: "1.6 – 1.8 mS/cm (1000 – 1200 ppm)",
    pH: "5 to 7",
    Timer: "Timer: 30 minutes on and 3Hrs off",
    tankMaintenance: "",
    spraySchedule: "",
  },
  {
    Day: 73,
    EC: "1.6 – 1.8 mS/cm (1000 – 1200 ppm)",
    pH: "5 to 7",
    Timer: "Timer: 30 minutes on and 3Hrs off",
    tankMaintenance: "",
    spraySchedule: "",
  },
  {
    Day: 74,
    EC: "1.6 – 1.8 mS/cm (1000 – 1200 ppm)",
    pH: "5 to 7",
    Timer: "Timer: 30 minutes on and 3Hrs off",
    tankMaintenance: "",
    spraySchedule: "",
  },
  {
    Day: 75,
    EC: "1.6 – 1.8 mS/cm (1000 – 1200 ppm)",
    pH: "5 to 7",
    Timer: "Timer: 30 minutes on and 3Hrs off",
    tankMaintenance: "",
    spraySchedule: "",
  },
  {
    Day: 76,
    EC: "1.6 – 1.8 mS/cm (1000 – 1200 ppm)",
    pH: "5 to 7",
    Timer: "Timer: 30 minutes on and 3Hrs off",
    tankMaintenance: "",
    spraySchedule: "",
  },
  {
    Day: 77,
    EC: "1.6 – 1.8 mS/cm (1000 – 1200 ppm)",
    pH: "5 to 7",
    Timer: "Timer: 30 minutes on and 3Hrs off",
    tankMaintenance: "",
    spraySchedule: "",
  },
  {
    Day: 78,
    EC: "1.6 – 1.8 mS/cm (1000 – 1200 ppm)",
    pH: "5 to 7",
    Timer: "Timer: 30 minutes on and 3Hrs off",
    tankMaintenance: "",
    spraySchedule: "",
  },
  {
    Day: 79,
    EC: "1.6 – 1.8 mS/cm (1000 – 1200 ppm)",
    pH: "5 to 7",
    Timer: "Timer: 30 minutes on and 3Hrs off",
    tankMaintenance: "",
    spraySchedule: "",
  },
  {
    Day: 80,
    EC: "1.6 – 1.8 mS/cm (1000 – 1200 ppm)",
    pH: "5 to 7",
    Timer: "Timer: 30 minutes on and 3Hrs off",
    tankMaintenance: "Flush & refill nutrients",
    spraySchedule: "",
  },
  {
    Day: 81,
    EC: "1.6 – 1.8 mS/cm (1000 – 1200 ppm)",
    pH: "5 to 7",
    Timer: "Timer: 30 minutes on and 3Hrs off",
    tankMaintenance: "",
    spraySchedule: "Bt Spray (2ml/L) or Trichoderma (2ml/L)",
  },
  {
    Day: 82,
    EC: "1.6 – 1.8 mS/cm (1000 – 1200 ppm)",
    pH: "5 to 7",
    Timer: "Timer: 30 minutes on and 3Hrs off",
    tankMaintenance: "",
    spraySchedule: "",
  },
  {
    Day: 83,
    EC: "1.6 – 1.8 mS/cm (1000 – 1200 ppm)",
    pH: "5 to 7",
    Timer: "Timer: 30 minutes on and 3Hrs off",
    tankMaintenance: "",
    spraySchedule: "",
  },
  {
    Day: 84,
    EC: "1.6 – 1.8 mS/cm (1000 – 1200 ppm)",
    pH: "5 to 7",
    Timer: "Timer: 30 minutes on and 3Hrs off",
    tankMaintenance: "",
    spraySchedule: "",
  },
  {
    Day: 85,
    EC: "1.6 – 1.8 mS/cm (1000 – 1200 ppm)",
    pH: "5 to 7",
    Timer: "Timer: 30 minutes on and 3Hrs off",
    tankMaintenance: "",
    spraySchedule: "",
  },
  {
    Day: 86,
    EC: "1.6 – 1.8 mS/cm (1000 – 1200 ppm)",
    pH: "5 to 7",
    Timer: "Timer: 30 minutes on and 3Hrs off",
    tankMaintenance: "",
    spraySchedule: "Micronutrient Spray (2ml/L)",
  },
  {
    Day: 87,
    EC: "1.6 – 1.8 mS/cm (1000 – 1200 ppm)",
    pH: "5 to 7",
    Timer: "Timer: 30 minutes on and 3Hrs off",
    tankMaintenance: "",
    spraySchedule: "",
  },
  {
    Day: 88,
    EC: "1.6 – 1.8 mS/cm (1000 – 1200 ppm)",
    pH: "5 to 7",
    Timer: "Timer: 30 minutes on and 3Hrs off",
    tankMaintenance: "",
    spraySchedule: "",
  },
  {
    Day: 89,
    EC: "1.6 – 1.8 mS/cm (1000 – 1200 ppm)",
    pH: "5 to 7",
    Timer: "Timer: 30 minutes on and 3Hrs off",
    tankMaintenance: "",
    spraySchedule: "",
  },
  {
    Day: 90,
    EC: "1.6 – 1.8 mS/cm (1000 – 1200 ppm)",
    pH: "5 to 7",
    Timer: "Timer: 30 minutes on and 3Hrs off",
    tankMaintenance: "",
    spraySchedule: "",
  },
];
const CreateCropUpdate = () => {
  let userData = useSelector((store) => store.login.user);
  const [loading, setLoading] = useState(false);
  const [plantList, setPlantList] = useState([]);
  const [data, setData] = useState({});
  const navigate = useNavigate();
  const [isHandOverCompleted, setIsHandOverCompleted] = useState(false);

  useEffect(() => {
    performRequest("GET", "/handOver/getHandOver/")
      .then((res) => {
        if (res.status === 200) {
          if (res?.data?.handOverData?.length > 0) {
            setIsHandOverCompleted(true);
          } else {
            setIsHandOverCompleted(false);
          }
        } else {
          Toast("error", "Error while getting data!");
        }
      })
      .catch((err) => {
        CustomErrorResponse(err);
      });
  }, []);

  useEffect(() => {
    performRequest("GET", getFilteredURL("/cropUpdate/getCropUpdate/", 1, ""))
      .then((res) => {
        if (res.status === 200) {
          setData(res.data);
        } else {
          Toast("error", "Error while getting Data!");
        }
      })
      .catch((err) => {
        CustomErrorResponse(err);
      });
  }, []);

  const handleSubmit = (values, actions) => {
    if (values?.cropPhoto?.length < 1) {
      Toast("error", "Schedule not generated");
      return;
    }
    values = {
      ...values,
      genratedBy: userData?.UserId,
    };
    setLoading(true);
    performRequest("POST", "/cropUpdate/createCropUpdate/", values)
      .then((res) => {
        if (res.status === 201) {
          Toast("success", "Crop update created successfully!");
          navigate(`/farm-crop-schedule`);
        } else {
          Toast("error", "Error while creating water cycle");
        }
      })
      .catch((err) => {
        // Toast("error", "Server Error");
        // console.error("Error", err);
        CustomErrorResponse(err);
      })
      .finally(() => setLoading(false));
  };

  useEffect(() => {
    performRequest("GET", "/agronomyWiki/getAllAgronomyWiki/")
      .then((res) => {
        if (res.status === 200) {
          setPlantList(res?.data?.data || []);
        } else {
          Toast("error", "Error while getting data!");
        }
      })
      .catch((err) => {
        // Toast("error", "Server Error!");
        // console.error(err);
        CustomErrorResponse(err);
      });
  }, []);

  const generateDateLabels = (startdate, systemType) => {
    const schedule = [];
    if (systemType === "growBags") {
      for (let i = 0; i < growbagSchedule.length; i++) {
        const date = new Date(startdate);
        date.setDate(date.getDate() + i);

        schedule.push({
          date: date.toISOString().split("T")[0],
          ...growbagSchedule[i],
          cropUploadPhoto: "",
          scheduleDone: false,
          scheduleDoneDate: "",
        });
      }
    } else if (systemType === "nft-single-cycle") {
      for (let i = 0; i < nftSingleCycle.length; i++) {
        const date = new Date(startdate);
        date.setDate(date.getDate() + i);

        schedule.push({
          date: date.toISOString().split("T")[0],
          ...nftSingleCycle[i],
          cropUploadPhoto: "",
          scheduleDone: false,
          scheduleDoneDate: "",
        });
      }
    } else if (systemType === "nft-herbs") {
      for (let i = 0; i < nftHerbs.length; i++) {
        const date = new Date(startdate);
        date.setDate(date.getDate() + i);

        schedule.push({
          date: date.toISOString().split("T")[0],
          ...nftHerbs[i],
          cropUploadPhoto: "",
          scheduleDone: false,
          scheduleDoneDate: "",
        });
      }
    }

    return schedule;
  };

  if (loading) {
    return <LoadingPage />;
  }

  if (!isHandOverCompleted && data?.cropUpdateCount >= 1) {
    navigate("/farm-crop-schedule/");
  }

  return (
    <div className="page">
      <div className="page-wrapper">
        <div className="container-xxl">
          <div className="page-header d-print-none">
            <div className="row align-items-center">
              <div className="col-md-8">
                <h2 className="page-title mb-1">
                  <PiPottedPlantDuotone
                    className="fs-2 me-1"
                    style={{ color: "green" }}
                  />{" "}
                  Crop Schedule
                </h2>
                <h4 className="text-muted">Track & manage your crops.</h4>
              </div>
              <img
                src="https://res.cloudinary.com/bsgfcooa/image/upload/v1752557495/jailtumpiwipo21cqe2f_dmftrw.heic"
                alt=""
              />
              <div className="col-md-4">
                <div className="btn-list justify-content-start mt-1 mb-3">
                  <a href={"/farm-crop-schedule/"} className="btn btn-primary">
                    <PiPottedPlantDuotone className="fs-3 me-2" /> All Schedules
                  </a>
                </div>
              </div>
            </div>
          </div>

          <div className="row col-12">
            <div className="card">
              <Formik
                initialValues={cropUpdateInfo}
                validationSchema={cropUpdateInfoSchema}
                onSubmit={handleSubmit}
              >
                {(props) => (
                  <Form>
                    <div className="card-body">
                      <div className="mb-3 row">
                        <label className="w-25 form-label required col-3">
                          Crop name
                        </label>
                        <div className="w-100 col">
                          <CustomSelect
                            type="text"
                            name="cropName"
                            disabled={props.values?.cropPhoto?.length > 0}
                          >
                            <option value="">Select</option>
                            {plantList.map((plant) => (
                              <option key={plant.id} value={plant.name}>
                                {plant.name}
                              </option>
                            ))}
                          </CustomSelect>
                          {props.touched.cropName && props.errors.cropName && (
                            <p className="text-danger">
                              {props.errors.cropName}
                            </p>
                          )}
                        </div>
                      </div>
                      <div className="mb-3 row">
                        <label className="w-25 form-label required col-3">
                          Crop cycle name
                        </label>
                        <div className="w-100 col">
                          <CustomInput name="cropCycleName" type="text" />
                          {props.touched.cropCycleName &&
                            props.errors.cropCycleName && (
                              <p className="text-danger">
                                {props.errors.cropCycleName}
                              </p>
                            )}
                        </div>
                      </div>
                      <div className="mb-3 row">
                        <label className="w-25 form-label required col-3">
                          Type of system
                        </label>
                        <div className="w-100 col">
                          <CustomSelect
                            type="text"
                            name="typeOfSystem"
                            disabled={props.values?.cropPhoto?.length > 0}
                          >
                            <option value="">Select</option>
                            {/* <option value="a-frame">A-Frame</option>
                            <option value="flatBed">Flatbed</option> */}
                            <option value="growBags">Grow Bags</option>
                            <option value="nft-single-cycle">
                              NFT-Single Cycle
                            </option>
                            <option value="nft-herbs">NFT-Herbs</option>
                            {/* <option value="indoorHydroponic">
                              Indoor Hydroponic
                            </option> */}
                          </CustomSelect>
                          {props.touched.typeOfSystem &&
                            props.errors.typeOfSystem && (
                              <p className="text-danger">
                                {props.errors.typeOfSystem}
                              </p>
                            )}
                        </div>
                      </div>
                      <div className="mb-3 row">
                        <label className="w-25 form-label required col-3">
                          CEA system
                        </label>
                        <div className="w-100 col">
                          <CustomSelect type="text" name="ceaSystem">
                            <option value="">Select</option>
                            <option value="nvph">NVPH</option>
                            <option value="fanpad">Fanpad</option>
                            <option value="indoor">Indoor</option>
                            <option value="open cultivation">
                              Open Cultivation
                            </option>
                          </CustomSelect>
                          {props.touched.ceaSystem &&
                            props.errors.ceaSystem && (
                              <p className="text-danger">
                                {props.errors.ceaSystem}
                              </p>
                            )}
                        </div>
                      </div>
                      <div className="mb-3 row">
                        <label className="w-25 form-label required col-3">
                          Water tank capacity
                        </label>
                        <div className="w-100 col">
                          <CustomInput name="waterTankCapacity" type="text" />
                          {props.touched.waterTankCapacity &&
                            props.errors.waterTankCapacity && (
                              <p className="text-danger">
                                {props.errors.waterTankCapacity}
                              </p>
                            )}
                        </div>
                      </div>
                      <div className="mb-3 row">
                        <label className="w-25 form-label col-3 required">
                          Crop cycle start date
                        </label>
                        <div className="w-100 col">
                          <CustomInput
                            name="cropCycleStartDate"
                            type="date"
                            disabled={props.values?.cropPhoto?.length > 0}
                          />
                          {props.touched.cropCycleStartDate &&
                            props.errors.cropCycleStartDate && (
                              <p className="text-danger">
                                {props.errors.cropCycleStartDate}
                              </p>
                            )}
                        </div>
                      </div>
                      <div className="mb-3 row">
                        <label className="w-25 form-label required col-3">
                          Total crop count
                        </label>
                        <div className="w-100 col">
                          <CustomInput name="totalCropCount" type="text" />
                          {props.touched.totalCropCount &&
                            props.errors.totalCropCount && (
                              <p className="text-danger">
                                {props.errors.totalCropCount}
                              </p>
                            )}
                        </div>
                      </div>
                      <FieldArray name="cropPhoto">
                        {({ push, remove }) => (
                          <div>
                            {props.values?.cropPhoto.length > 0 && (
                              <table className="fs-5 table table-vcenter table-striped">
                                <thead>
                                  {props.values?.typeOfSystem ===
                                    "growBags" && (
                                    <tr>
                                      <th>Day</th>
                                      <th>Date</th>
                                      <th>Activity</th>
                                      <th>pH</th>
                                      <th>EC</th>
                                      <th> Timer</th>
                                      <th>Composition</th>
                                      {/* <th>crop Photo</th>
                                      <th>work Done</th>
                                      <th> Done Date</th> */}
                                    </tr>
                                  )}
                                  {props.values?.typeOfSystem ===
                                    "nft-single-cycle" && (
                                    <tr>
                                      <th>Day</th>
                                      <th>Date</th>
                                      <th>pH</th>
                                      <th>EC</th>
                                      <th>Timer</th>
                                      <th>Tank Maintenance</th>
                                      <th>Spray Schedule</th>
                                    </tr>
                                  )}
                                  {props.values?.typeOfSystem ===
                                    "nft-herbs" && (
                                    <tr>
                                      <th>Day</th>
                                      <th>Date</th>
                                      <th>pH</th>
                                      <th>EC</th>
                                      <th>Timer</th>
                                      <th>Tank Maintenance</th>
                                      <th>Spray Schedule</th>
                                    </tr>
                                  )}
                                </thead>
                                <tbody>
                                  {props.values?.cropPhoto?.map(
                                    (schedule, index) => {
                                      return (
                                        <tr key={index}>
                                          <td> {schedule.Day}.</td>
                                          <td>{schedule.date}</td>
                                          {props.values?.typeOfSystem ===
                                            "growBags" && (
                                            <td>
                                              {schedule.Activity || "---"}
                                            </td>
                                          )}
                                          <td>{schedule.pH || "---"}</td>
                                          <td>{schedule.EC || "---"}</td>

                                          <td>{schedule.Timer || "---"}</td>

                                          {props.values?.typeOfSystem ===
                                            "growBags" && (
                                            <td>
                                              {" "}
                                              {schedule.Composition || "---"}
                                            </td>
                                          )}
                                          {props.values?.typeOfSystem !==
                                            "growBags" && (
                                            <td>
                                              {schedule.tankMaintenance ||
                                                "---"}
                                            </td>
                                          )}
                                          {props.values?.typeOfSystem !==
                                            "growBags" && (
                                            <td>
                                              {schedule.spraySchedule || "---"}
                                            </td>
                                          )}
                                          {/* <td>
                                            <div className="w-100 col">
                                              <CustomInput
                                                name={`cropPhoto[${index}].cropUploadPhoto`}
                                                type="file"
                                                onChange={(e) =>
                                                  uploadImage(
                                                    props,
                                                    `cropPhoto[${index}].cropUploadPhoto`,
                                                    e.target.files[0]
                                                  )
                                                }
                                              />
                                              {props.touched.cropPhoto?.[index]
                                                ?.cropUploadPhoto &&
                                                props.errors.cropPhoto?.[index]
                                                  ?.cropUploadPhoto && (
                                                  <p className="text-danger">
                                                    {
                                                      props.errors.cropPhoto[
                                                        index
                                                      ].cropUploadPhoto
                                                    }
                                                  </p>
                                                )}
                                            </div>
                                          </td>
                                          <td>
                                            <CustomCheckbox
                                              type="checkbox"
                                              width={"23px"}
                                              height={"23px"}
                                              name={`cropPhoto[${index}].scheduleDone`}
                                              onChange={(e) => {
                                                props.setFieldValue(
                                                  `cropPhoto[${index}].scheduleDone`,
                                                  !schedule.scheduleDone
                                                );
                                                let date = new Date();
                                                props.setFieldValue(
                                                  `cropPhoto[${index}].scheduleDoneDate`,
                                                  !schedule.scheduleDone
                                                    ? date
                                                        .toISOString()
                                                        .split("T")[0]
                                                    : ""
                                                );
                                              }}
                                            ></CustomCheckbox>
                                          </td>
                                          <td>
                                            {schedule.scheduleDoneDate || "---"}
                                          </td> */}
                                        </tr>
                                      );
                                    }
                                  )}
                                </tbody>
                              </table>
                            )}

                            <button
                              className="btn btn-primary mt-4"
                              type="button"
                              disabled={props.values?.cropPhoto?.length > 0}
                              // onClick={() => {
                              //   if (props.values.cropPhoto.length === 0) {
                              //     push({
                              //       cropUploadPhoto: "",
                              //       updateDate: new Date()
                              //         .toISOString()
                              //         .split("T")[0],
                              //     });
                              //   } else if (
                              //     props.values.cropPhoto.length > 0 &&
                              //     checkTouched(
                              //       props.values.cropPhoto[
                              //         props.values.cropPhoto.length - 1
                              //       ]
                              //     )
                              //   ) {
                              //     push({
                              //       cropUploadPhoto: "",
                              //       updateDate: new Date()
                              //         .toISOString()
                              //         .split("T")[0],
                              //     });
                              //   } else {
                              //     Toast(
                              //       "error",
                              //       "Please fill at least one line item field."
                              //     );
                              //   }
                              // }}
                              onClick={() => {
                                if (
                                  !props.values.cropName ||
                                  !props.values.cropCycleName ||
                                  !props.values.waterTankCapacity ||
                                  !props.values.totalCropCount ||
                                  !props.values.ceaSystem ||
                                  !props.values.cropCycleStartDate ||
                                  !props.values.typeOfSystem
                                ) {
                                  Toast(
                                    "error",
                                    "Please fill all the required fields before generating the schedule."
                                  );
                                  return;
                                }
                                const schedule = generateDateLabels(
                                  props.values.cropCycleStartDate,
                                  props.values.typeOfSystem
                                );
                                props.setFieldValue("cropPhoto", schedule);
                              }}
                            >
                              Generate crop schedule
                            </button>
                          </div>
                        )}
                      </FieldArray>
                    </div>
                    <div className="card-footer">
                      <div className="btn-list justify-content-end">
                        <FormSubmitButton buttonText="Create crop schedule" />
                        <SimpleButton buttonText="Cancel" type="secondary" />
                      </div>
                    </div>
                  </Form>
                )}
              </Formik>
            </div>
          </div>
        </div>
        <Footer />
      </div>
    </div>
  );
};

export default CreateCropUpdate;
